module.exports = __webpack_public_path__ + "cf10939d9b4b6d8b52dc862717171fa6.png";